let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("habZa")).then(() => parcelRequire('4EPe2'));